import { Box, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import useCategoryDetails from './category-details.hook';
import CategoryForm from './components/category-form';
import ProductsListByTheme from '../theme-details/components/products-list-by-theme';

export default function CategoryDetails() {
  const { isEdit, loadingCategoryDetails, methods, onSubmit, isSubmitting } = useCategoryDetails();
  return (
    <Page title={isEdit ? 'Editar Categoria' : 'Cadastrar Categoria'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={isEdit ? 'Editar Categoria' : 'Cadastrar Categoria'}
          links={[]}
          sx={{ mb: 3 }}
        />
        {loadingCategoryDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <Stack spacing={2}>
            <CategoryForm
              methods={methods}
              onSubmit={onSubmit}
              isEdit={isEdit}
              isSubmitting={isSubmitting}
            />
            {isEdit && <ProductsListByTheme fixedFilter="category" />}
          </Stack>
        )}
      </Container>
    </Page>
  );
}
